export const MODAL_DIALOG_OPEN = 'MODAL_DIALOG_OPEN'
export const MODAL_DIALOG_CLOSE = 'MODAL_DIALOG_CLOSE'

const open = (content) => ({
  type: MODAL_DIALOG_OPEN,
  content,
  isModalDialogOpen: true,
})

const close = () => ({
  type: MODAL_DIALOG_CLOSE,
  isModalDialogOpen: false,
})

export const openModalDialog = (content) => (dispatch) => dispatch(open(content))

export const closeModalDialog = () => (dispatch) => dispatch(close())
